import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, Row, Spinner } from "react-bootstrap";
import EditProfileModal from "./EditProfileModal";
import "../../styles/dashboard.css"
import Cookies from "js-cookie";
import api from "../../api.js";

const ProfileView = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  
    const token = Cookies.get("access_token");
    const currentuser = Cookies.get("user_id");

  useEffect(() => {
    api
      .get(`/profile/${currentuser}/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setUser(res.data))
      .catch((err) => console.error("Error loading profile:", err))
      .finally(() => setLoading(false));
  }, []);

  return (
  
    <div className="p-3">
      {loading ? (
        <Spinner animation="border" />
      ) : user ? (
        <Row className="mb-4 gx-4 gy-3">
        <div className="card1">
          <p><strong>نام کاربری:</strong> {user.username}</p>
          <p><strong>ایمیل:</strong> {user.email}</p>
          <Button className="mt-4" onClick={() => setShowModal(true)}>ویرایش پروفایل</Button>
          <EditProfileModal show={showModal} onClose={() => setShowModal(false)} user={user} onUpdate={setUser} />
        </div>
        </Row>
      ) : (
        <p>کاربری یافت نشد</p>
              
      )
      
      }

      {/* <Row className="mb-4 gx-4 gy-3">
<div class="container py-5">
  <div class="row row-cols-1 row-cols-md-4 g-4">
    <div class="col">
      <div class="card h-100 text-center shadow">
        <div class="card-body">
          <div class="display-4 text-primary mb-2">
            <i class="bi bi-people"></i>
          </div>
          <h2 class="card-title mb-3">1,234</h2>
          <p class="card-text text-muted">Active Users</p>
        </div>
      </div>
    </div>
    
    <div class="col">
      <div class="card h-100 text-center shadow">
        <div class="card-body">
          <div class="display-4 text-success mb-2">
            <i class="bi bi-graph-up"></i>
          </div>
          <h2 class="card-title mb-3">56%</h2>
          <p class="card-text text-muted">Growth Rate</p>
        </div>
      </div>
    </div>
    
    <div class="col">
      <div class="card h-100 text-center shadow">
        <div class="card-body">
          <div class="display-4 text-warning mb-2">
            <i class="bi bi-star"></i>
          </div>
          <h2 class="card-title mb-3">4.8</h2>
          <p class="card-text text-muted">Average Rating</p>
        </div>
      </div>
    </div>
    
    <div class="col">
      <div class="card h-100 text-center shadow">
        <div class="card-body">
          <div class="display-4 text-danger mb-2">
            <i class="bi bi-clock-history"></i>
          </div>
          <h2 class="card-title mb-3">98.3%</h2>
          <p class="card-text text-muted">Uptime</p>
        </div>
      </div>
    </div>
  </div>
</div>
</Row> */}
    </div>
    
    
  );
};

export default ProfileView;
